import useHttpPost from "./useHttpPost";

export default function usePostVehicleMake(target){
    return useHttpPost("vehiclemake", "post", {}, target)
}